<template>
	<div class="then-box">
		<div class="logo">
			<img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/logo-max.png" >
		</div>
		<div class="logo-bonnt">
			支付成功，正在获取添加辅导老师信息...
		</div>
		<div class="por-fi">
			<div class="button">
				<a :href="openlink"><van-button size="small">添加辅导老师</van-button></a>
			</div>
			<div class="tishi">若自动跳转微信失败，请点击添加辅导老师按钮跳转微信</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				openlink:''
			}
		},
		created() {
			this.$API.wechatUrlScheme({
				path:'pages/qscode/index',
				query:`id=${this.$route.query.oid}`
			}).then(res => {
				this.openlink = res.data.openlink;
				window.location.href = res.data.openlink;
			})
		}
	}
</script>

<style scoped lang="stylus">
	.then-box{
		.logo{
			text-align center
			padding-top :1.8rem;
			img{
				height:0.8rem;
			}
		}
		.logo-bonnt{
			font-size : 0.26rem;
			text-align: center;
			color :#494949;
			margin-top :0.4rem;
		}
		.por-fi{
			position: fixed;
			bottom :1.4rem;
			width :100%;
			text-align :center;
			.tishi{
				font-size : 0.22rem;
				color :#999;
				margin-top :0.6rem;
			}
		}
	}
</style>
